'use client';

import { useClientTranslation } from '@lib/i18n/client';

import type { Locale } from '@tuic/i18n';
import type { FC } from 'react';

type Props = {
  locale: Locale;
};

export const SetClientLocale: FC<Props> = ({ locale }) => {
  useClientTranslation(locale);

  return null;
};
